import React from "react";

const ForwardIcon = () => (
  <svg
    id="Group_53"
    data-name="Group 53"
    xmlns="http://www.w3.org/2000/svg"
    width="19.429"
    height="16"
    viewBox="0 0 19.429 16"
  >
    <defs>
      <clipPath id="clip-path">
        <path
          id="Icon"
          d="M9.426,4.515a2.277,2.277,0,0,1,.371.02V0l9.632,7.254L9.8,14.413V9.441a3.909,3.909,0,0,0-1.2-.122A8.721,8.721,0,0,0,.311,16,9.107,9.107,0,0,1,0,13.774,9.334,9.334,0,0,1,9.426,4.515"
          fill="#8a8a8e"
        />
      </clipPath>
    </defs>
    <path
      id="Icon-2"
      data-name="Icon"
      d="M9.426,4.515a2.277,2.277,0,0,1,.371.02V0l9.632,7.254L9.8,14.413V9.441a3.909,3.909,0,0,0-1.2-.122A8.721,8.721,0,0,0,.311,16,9.107,9.107,0,0,1,0,13.774,9.334,9.334,0,0,1,9.426,4.515"
      fill="#8a8a8e"
    />
  </svg>
);

export default ForwardIcon;
